import _ from 'lodash';

/**
 * Created by or_p on 6/27/2016.
 */

import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import Menu from 'material-ui/Menu';
import MenuItem from 'material-ui/MenuItem';
import Divider from 'material-ui/Divider';
import { lockElement, unlockElement, sendToFront, sendBackward, sendForward, sendToBack } from 'crazyEditor/redux/modules/element/actions/elementPropsActions';
import { deleteElement, duplicateDesktopElement, updateDesktopElement } from 'crazyEditor/redux/modules/element/actions/desktopElementActions';
import {PAGE_ELEMENT_ID} from '../../../../core/elements/utils/elementStaticUtils';
import styles from './ContextMenuStyles';
import { CustomSvgIcon } from 'crazyEditor/components/EditorUI/BaseUI/index';
import { hideMobileElement } from 'crazyEditor/redux/modules/element/actions/mobileElementActions';
import * as Colors from 'material-ui/styles/colors';
import {isEditable} from 'crazyEditor/core/elements/utils/elementAddUpdateUtils';
import Paper from 'material-ui/Paper';
import {getSelectedElements, isMultiSelect} from 'crazyEditor/redux/modules/element/elementSelectors';
import {getNormalizedTemplateTagSpecifics} from 'crazyEditor/redux/modules/templateTagSet/templateTagSelectors';
import ArrowDropRight from 'material-ui/svg-icons/navigation-arrow-drop-right';
import {isVirtualClipBoardEmpty} from '../CopyPasteListener/CopyPasteUtils';
import shallowEqual from 'fbjs/lib/shallowEqual';

@connect(
  (state) => ({
    viewMode: state.editor.viewMode,
    isDesktopView: state.editor.isDesktopView,
    isMobileView: state.editor.isMobileView,
    selectedElementIds: state.stage.selectedElementIds,
    isMultiSelect: isMultiSelect(state),
    templateTagSpecifics: getNormalizedTemplateTagSpecifics(state),
    selectedElements: getSelectedElements(state),
    isAdmin: state.user.isAdmin
  }),
  {
    lockElement,
    unlockElement,
    deleteElement,
    duplicateDesktopElement,
    sendToFront,
    sendBackward,
    sendForward,
    sendToBack,
    hideMobileElement,
    updateDesktopElement,
  }
)
export default class ContextMenu extends Component {

  shouldComponentUpdate(nextProps, nextState) {
    const mainProps = ['selectedElementIds', 'selectedElements', 'position'];
    return !(shallowEqual(_.pick(this.props, mainProps), _.pick(nextProps, mainProps)) && shallowEqual(this.state, nextState));
  }


  getTemplateTagSetItems() {
    const {isAdmin, templateTagSpecifics, selectedElements, updateDesktopElement, selectedElementIds, isMobileView} = this.props;
    if (isMobileView || !isAdmin || _.isEmpty(templateTagSpecifics)) {
      return [];
    }
    return [
      {
        title: 'Tag',
        rightIcon: <ArrowDropRight />,
        menuItems: _.map(_.filter(templateTagSpecifics, tag => !!tag.name), tag => {
          const checked = _.get(selectedElements, '[0].data.templateTag') === tag.name;
          return (
            <MenuItem
              key={tag.name}
              primaryText={tag.displayName}
              onMouseDown={(event) => {
                event.stopPropagation();
                /* prevent mouse down propagating to mouse catcher */
              }}
              onClick={() => _.defer(() => {
                updateDesktopElement(selectedElementIds, {data: {templateTag: checked ? null : tag.name}});
              })}
              checked={checked}
            />
          );
        }),
      },
      null,
    ];
  }

  getMenuItems({ copyPasteListenerRef, isMultiSelect, viewMode, selectedElements, selectedElementIds, lockElement, unlockElement, deleteElement, duplicateDesktopElement, sendToFront, sendBackward, sendForward, sendToBack, onEdit, isDesktopView, hideMobileElement }) {
    if (_.isEmpty(selectedElements)) {
      return [];
    }
    let menuItems = [];
    if (isDesktopView && !isMultiSelect && isEditable(selectedElements[0])) {
      menuItems = [
        {
          title: 'Edit',
          svgPath: 'M20.71,7.04C21.1,6.65 21.1,6 20.71,5.63L18.37,3.29C18,2.9 17.35,2.9 16.96,3.29L15.12,5.12L18.87,8.87M3,17.25V21H6.75L17.81,9.93L14.06,6.18L3,17.25Z',
          onClick: () => _.defer(onEdit),
        },
        null];
    }
    menuItems = menuItems.concat(this.getTemplateTagSetItems());
    menuItems = menuItems.concat([
      {
        title: 'Send to back',
        svgPath: 'M2,2H11V11H2V2M9,4H4V9H9V4M22,13V22H13V13H22M15,20H20V15H15V20M16,8V11H13V8H16M11,16H8V13H11V16Z',
        onClick: () => sendToBack(viewMode, selectedElementIds),
      },
      {
        title: 'Bring to front',
        svgPath: 'M2,2H11V6H9V4H4V9H6V11H2V2M22,13V22H13V18H15V20H20V15H18V13H22M8,8H16V16H8V8Z',
        onClick: () => sendToFront(viewMode, selectedElementIds),
      },
      {
        title: 'Step forward',
        svgPath: 'M2,2H16V16H2V2M22,8V22H8V18H10V20H20V10H18V8H22Z',
        onClick: () => sendForward(viewMode, selectedElementIds),
      },
      {
        title: 'Step backward',
        svgPath: 'M2,2H16V16H2V2M22,8V22H8V18H18V8H22M4,4V14H14V4H4Z',
        onClick: () => sendBackward(viewMode, selectedElementIds),
      },
      null]);
    if (isDesktopView) {
      menuItems = menuItems.concat([
        {
          title: 'Copy',
          svgPath: 'M19,21H8V7H19M19,5H8A2,2 0 0,0 6,7V21A2,2 0 0,0 8,23H19A2,2 0 0,0 21,21V7A2,2 0 0,0 19,5M16,1H4A2,2 0 0,0 2,3V17H4V3H16V1Z',
          onClick: () => copyPasteListenerRef.handleElementsCopy(),
        },
        {
          title: 'Paste',
          svgPath: 'M19,20H5V4H7V7H17V4H19M12,2A1,1 0 0,1 13,3A1,1 0 0,1 12,4A1,1 0 0,1 11,3A1,1 0 0,1 12,2M19,2H14.82C14.4,0.84 13.3,0 12,0C10.7,0 9.6,0.84 9.18,2H5A2,2 0 0,0 3,4V20A2,2 0 0,0 5,22H19A2,2 0 0,0 21,20V4A2,2 0 0,0 19,2Z',
          onClick: () => copyPasteListenerRef.handleElementsPaste(),
          disabled: isVirtualClipBoardEmpty(),
        },
        {
          title: 'Duplicate',
          svgPath: 'M11,17H4A2,2 0 0,1 2,15V3A2,2 0 0,1 4,1H16V3H4V15H11V13L15,16L11,19V17M19,21V7H8V13H6V7A2,2 0 0,1 8,5H19A2,2 0 0,1 21,7V21A2,2 0 0,1 19,23H8A2,2 0 0,1 6,21V19H8V21H19Z',
          onClick: () => duplicateDesktopElement(selectedElementIds),
        },
        {
          title: 'Delete',
          svgPath: 'M19,4H15.5L14.5,3H9.5L8.5,4H5V6H19M6,19A2,2 0 0,0 8,21H16A2,2 0 0,0 18,19V7H6V19Z',
          onClick: () => deleteElement(selectedElementIds),
        },
        null,
      ]);
    } else {
      menuItems.push({
        title: 'Hide',
        svgPath: 'M 11.83 9 L 15 12.16 C 15 12.11 15 12.05 15 12 A 3 3 0 0 0 12 9 C 11.94 9 11.89 9 11.83 9 M 7.53 9.8 L 9.08 11.35 C 9.03 11.56 9 11.77 9 12 A 3 3 0 0 0 12 15 C 12.22 15 12.44 14.97 12.65 14.92 L 14.2 16.47 C 13.53 16.8 12.79 17 12 17 A 5 5 0 0 1 7 12 C 7 11.21 7.2 10.47 7.53 9.8 M 2 4.27 L 4.28 6.55 L 4.73 7 C 3.08 8.3 1.78 10 1 12 C 2.73 16.39 7 19.5 12 19.5 C 13.55 19.5 15.03 19.2 16.38 18.66 L 16.81 19.08 L 19.73 22 L 21 20.73 L 3.27 3 M 12 7 A 5 5 0 0 1 17 12 C 17 12.64 16.87 13.26 16.64 13.82 L 19.57 16.75 C 21.07 15.5 22.27 13.86 23 12 C 21.27 7.61 17 4.5 12 4.5 C 10.6 4.5 9.26 4.75 8 5.2 L 10.17 7.35 C 10.74 7.13 11.35 7 12 7 Z',
        onClick: () => hideMobileElement(selectedElementIds),
      });
    }
    if (_.get(selectedElements[0], 'locked', false)) {
      menuItems.push({
        title: 'Unlock',
        svgPath: 'M18,8A2,2 0 0,1 20,10V20A2,2 0 0,1 18,22H6C4.89,22 4,21.1 4,20V10A2,2 0 0,1 6,8H15V6A3,3 0 0,0 12,3A3,3 0 0,0 9,6H7A5,5 0 0,1 12,1A5,5 0 0,1 17,6V8H18M12,17A2,2 0 0,0 14,15A2,2 0 0,0 12,13A2,2 0 0,0 10,15A2,2 0 0,0 12,17Z"',
        onClick: () => unlockElement(viewMode, selectedElementIds),
      });
    } else {
      menuItems.push({
        title: 'Lock',
        svgPath: 'M12,17A2,2 0 0,0 14,15C14,13.89 13.1,13 12,13A2,2 0 0,0 10,15A2,2 0 0,0 12,17M18,8A2,2 0 0,1 20,10V20A2,2 0 0,1 18,22H6A2,2 0 0,1 4,20V10C4,8.89 4.9,8 6,8H7V6A5,5 0 0,1 12,1A5,5 0 0,1 17,6V8H18M12,3A3,3 0 0,0 9,6V8H15V6A3,3 0 0,0 12,3Z',
        onClick: () => lockElement(viewMode, selectedElementIds),
      });
    }
    return menuItems;
  }

  render() {
    const {selectedElementIds, position, onRequestClose} = this.props;
    const menuItems = this.getMenuItems(this.props);
    const {x, y} = position || {};
    if (!position || _.isEmpty(menuItems) || selectedElementIds[0] === PAGE_ELEMENT_ID) {
      return null;
    }
    return (
      <Paper
        key={selectedElementIds}
        transitionEnabled={false}
        style={{position: 'fixed', top: y, left: x, zIndex: styles.wrapper.zIndex }}
      >
        <Menu
          onEscKeyDown={onRequestClose}
          desktop
        >
          {
            _.map(menuItems, (menuItem, index) => {
              if (menuItem === null) {
                return <Divider key={index}/>;
              }
              const {title, onClick, svgPath, ...other} = menuItem;
              return (<MenuItem
                key = {index}
                primaryText = {title}
                leftIcon = {<CustomSvgIcon path = {svgPath} color={Colors.grey700}/>}
                onMouseDown = {(event) => {event.stopPropagation(); /* prevent mouse down propagating to mouse catcher */}}
                onClick = {(event) => {
                  if (menuItem.menuItems) {
                    /* prevent close by mouse catcher */
                    event.nativeEvent.stopImmediatePropagation();
                  }
                  if (onClick) {
                    onClick();
                  }
                }}
                {...other}
              />);
            })
          }
        </Menu>
      </Paper>
    );
  }
}

ContextMenu.propTypes = {
  position: PropTypes.object,
  onRequestClose: PropTypes.func.isRequired,
  onEdit: PropTypes.func.isRequired,
  copyPasteListenerRef: PropTypes.object.isRequired,
};
